import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

export function useSearchParam(searchParam) {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchParamValue = searchParams.get(searchParam) || '';

  const isSearchActive = searchParamValue !== '';

  const updateSearchParam = useCallback(
    (newValue) => {
      setSearchParams({ [searchParam]: newValue });
    },
    [searchParam, setSearchParams]
  );

  const clearAllSearchParams = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  return {
    searchParamValue,
    isSearchActive,
    updateSearchParam,
    clearAllSearchParams
  };
}
